import React, { useState, useEffect } from "react";
import axios from "axios";
import whySenior from '../../assets/whySenior.svg';
import { Trophy, Users, BarChart3, ArrowRight } from "lucide-react";

const WhySenior = () => {
    const [visitorCount, setVisitorCount] = useState(0);

    useEffect(() => {
        const fetchCount = async () => {
            try {
                const res = await axios.post("/updateCount", {});
                setVisitorCount(res.data.count);
            } catch (error) {
                console.error("Failed to fetch visitor count", error);
            }
        };
        fetchCount();
    }, []);

    return (
        <section className="relative py-20 px-6 md:px-[10%] overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
                <div className="absolute top-[20%] right-[-10%] w-[500px] h-[500px] bg-blue-500/10 rounded-full blur-[100px]" />
                <div className="absolute bottom-[10%] left-[-10%] w-[400px] h-[400px] bg-purple-500/10 rounded-full blur-[100px]" />
            </div>

            <div className="relative z-10 max-w-7xl mx-auto ">
                <div className="text-center mb-4">
                    <h2 className=" font-bold text-3xl text-black pt-2 pb-3  md:text-5xl md:pb-10 dark:text-white">
                        Why Senior?
                    </h2>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-10">
                    
                    <div className="relative flex justify-center lg:justify-end order-2 lg:order-1">
                        <div className="relative z-10 bg-gradient-to-tr from-blue-100 to-purple-100 dark:from-white/10 dark:to-white/5 p-10 rounded-[3rem] shadow-2xl backdrop-blur-sm border border-white/50 dark:border-white/10">
                            <img 
                                src={whySenior} 
                                alt="Why Senior Illustration" 
                                className="w-full max-w-sm drop-shadow-lg transform hover:scale-105 transition-transform duration-500" 
                            />
                        </div>
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-blue-600/5 dark:bg-blue-500/20 rounded-full blur-3xl -z-10"></div>
                    </div>

                    <div className="order-1 lg:order-2 text-center lg:text-left">
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full text-sm font-bold mb-6">
                            <Trophy size={16} />
                            <span>Award Winning Mentorship</span>
                        </div>
                        
                        <h3 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6">
                            Master Competitive Programming with the Best
                        </h3>
                        
                        <p className="text-lg text-gray-600 dark:text-white/90 mb-8 leading-relaxed font-medium">
                            Our curriculum is crafted by <span className="font-bold text-blue-600 dark:text-white underline decoration-blue-400">top rated competitive programmers.</span> We bridge the gap between theoretical knowledge and practical application, helping you crack the toughest coding interviews globally.
</p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <a 
                                href="https://forms.gle/qbnXUcy6iT3RXS4B9" 
                                target="_blank" 
                                rel="noreferrer"
                                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-black dark:bg-white text-white dark:text-black rounded-full font-bold text-lg transition-all shadow-lg hover:bg-blue dark:hover:bg-blue hover:text-white dark:hover:text-white hover:shadow-blue-500/30 transform hover:-translate-y-1"
                            >
                                Register for Bootcamp
                                <ArrowRight size={20} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white dark:bg-[#0651c3] p-8 rounded-3xl shadow-lg border border-gray-100 dark:border-white/10 text-center transform hover:-translate-y-1 transition-all duration-300">
                        <div className="w-14 h-14 mx-auto  rounded-2xl flex items-center justify-center text-black dark:text-white mb-4">
                            <Users size={32} />
                        </div>
                        <h4 className="text-4xl font-extrabold text-gray-900 dark:text-white mb-2">
                            {visitorCount ? visitorCount.toLocaleString() : "10K+"}
                        </h4>
                        <p className="text-gray-500 dark:text-white/80 font-medium">Total Visitors</p>
                    </div>

                    <div className="bg-white dark:bg-[#0651c3] p-8 rounded-3xl shadow-lg border border-gray-100 dark:border-white/10 text-center transform hover:-translate-y-1 transition-all duration-300">
                        <div className="w-14 h-14 mx-auto  rounded-2xl flex items-center justify-center text-black dark:text-white mb-4">
                            <Trophy size={32} />
                        </div>
                        <h4 className="text-4xl font-extrabold text-gray-900 dark:text-white mb-2">
                            Top 1%
                        </h4>
                        <p className="text-gray-500 dark:text-white/80 font-medium">Global Ranking Mentors</p>
                    </div>

                    <div className="bg-white dark:bg-[#0651c3] p-8 rounded-3xl shadow-lg border border-gray-100 dark:border-white/10 text-center transform hover:-translate-y-1 transition-all duration-300">
                        <div className="w-14 h-14 mx-auto  rounded-2xl flex items-center justify-center text-black dark:text-white mb-4">
                            <BarChart3 size={32} />
                        </div>
                        <h4 className="text-4xl font-extrabold text-gray-900 dark:text-white mb-2">
                            100+
                        </h4>
                        <p className="text-gray-500 dark:text-white/80 font-medium">Daily Active Learners</p>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default WhySenior;